<template>
  <div class="c2025-topic">
    <div class="title">
      <img
        v-if="iconImageUrl"
        :src="`${$t('baseurl')}${iconImageUrl}`"
        alt=""
        loading="lazy"
      />
      <h3 v-html="title"></h3>
    </div>
    <div class="p-2 mx-n2">
      <b-row>
        <b-col
          class="px-3"
          :lg="hasThumbnail ? 7 : 12"
        >
          <div
            class="mt-3"
            v-html="description"
          ></div>
        </b-col>
        <b-col
          class="px-3"
          lg="5"
        >
          <div
            v-if="hasThumbnail"
            class="img-thumbnail why-tube-img text-center position-relative mt-4"
          >
            <button v-b-modal.modal="`modal-preview-${index}`">
              <img
                alt=""
                class="img-fluid"
                :src="`${$t('baseurl')}${thumbnailImageUrl}`"
                loading="lazy"
              />
              <span
                class="sr-only"
                v-html="$t('c2025.topics.thumbnail.text')"
              ></span>
            </button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      class="d-flex flex-wrap align-items-center justify-content-center mb-2"
      style="gap: 1rem"
    >
      <a
        v-if="isPublished"
        :href="presentationLinkUrl"
        class="btn btn-outline-warning"
        target="_blank"
        rel="noopener"
      >
        {{ $t('c2025.topics.buttons.read') }}
      </a>
      <b-button
        v-else
        variant="outline-warning"
        disabled
      >
        {{ $t('c2025.topics.buttons.read_soon') }}
      </b-button>
      <a
        :href="serviceLinkUrl"
        class="btn btn-primary btn-warning"
        target="_blank"
        rel="noopener"
      >
        <i class="fas fa-arrow-up-right-from-square"></i>
        {{ $t('c2025.topics.buttons.access') }}
      </a>
    </div>
    <b-modal
      :id="`modal-preview-${index}`"
      centered
      hide-header
      hide-footer
    >
      <img
        alt=""
        :src="`${$t('baseurl')}${thumbnailImageUrl}`"
        loading="lazy"
        class="w-100"
      />
    </b-modal>
  </div>
</template>
<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  title: String,
  description: String,
  thumbnailImageUrl: String,
  iconImageUrl: {
    type: String,
    required: false,
  },
  presentationLinkUrl: {
    type: String,
    required: true,
  },
  serviceLinkUrl: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  publicationDate: {
    type: String,
    required: true,
  },
});

const hasThumbnail = computed(() => props.thumbnailImageUrl && props.thumbnailImageUrl !== 'null');

const isPublished = computed(() => {
  const pubDate = new Date(new Date(props.publicationDate).getTime() + 12 * 60 * 60 * 1000);
  const now = new Date();
  return pubDate <= now;
});

</script>

<style lang="scss">
.c2025-topic {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #fff;
  border-radius: 1.75rem;
  border: 2px solid #cc4e13;
  padding: .5rem 1.5rem;
  position: relative;
  z-index: 1;
  height: 100%;

  a {
    background-image: none;
    font-weight: bold;

    p {
      margin-bottom: .5rem;
    }

    p:last-of-type {
      line-height: 1.5;
    }
  }

  .title {
    display: flex;
    align-items: center;
    gap: 1rem;

    h3 {
      margin: -1.5rem auto 0.5rem 0;

      @media (min-width: 768px) {
        margin: -1.75rem 0 0 2.5rem;
      }

      background: var(--f-o6);
      border-radius: .5rem;
      color: #fff;
      font-family: 'Tovari Sans',
      sans-serif;
      font-size: 2rem;
      padding: .25rem .75rem 0rem;
      text-align: center;
      text-transform: uppercase;
      width: fit-content;
    }

    img {
      width: 75px;
      height: 75px;
      margin-top: -1.75rem;

      @media (min-width: 768px) {
        position: absolute;
        left: -20px;
        top: -35px;
        margin-top: 0;
      }
    }
  }

  .btn-outline-warning {
    background-color: white;

    &:disabled {
      opacity: 1;
    }

    &:not(:disabled):hover {
      color: white;
    }
  }

  .small {
    color: var(--f-g7) !important;
  }
}
</style>
